import styled from 'styled-components';

export const Text = styled.div`
    color: var(--Dark-Gray, #767676);
    text-align: center;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 5rem;
    margin-bottom: 11.85rem;
`;
// export const Length = styled.div`
//     font-size: 0.8rem;
//     font-weight: 600;
//     width: 100%;
// `;
